var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keyUsers)?_c('span',{staticClass:"keyUserOfUserWrapper"},[_vm._v(" "+_vm._s(_vm.benutzer)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }